import { redirect, useNavigate } from "react-router-dom"

export default function PDFPrintRedirect() {
    const navigate = useNavigate();
    navigate(`/`)
   return null
}